import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvConfigService {
  private config: any = {};

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<void> {
    // return new Promise<void>((resolve, reject) => {
    //   this.http.get("../../../../assets/common/env.config.json").subscribe((data: any) => {
    //     this.config = data;
    //     resolve();
    //   });
    // });
    return lastValueFrom(
      this.http.get<Record<string, any>>('/assets/common/env.config.json')
    )
    .then(cfg => {
      this.config = cfg;
    })
    .catch(err => {
      console.error('Failed to load env config:', err);
      return Promise.reject(err);
    });    
  }

  get(key: string): any { 
    return this.config[key];
  }
}
